import { useLanguage, languages } from "../context/LanguageContext";
import { Globe } from "lucide-react";
import { useState, useRef, useEffect } from "react";

export const LanguageSwitcher = () => {
  const { lang, setLang } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const current = languages.find((l) => l.code === lang);

  return (
    <div ref={ref} className="relative" data-testid="language-switcher">
      <button
        onClick={() => setOpen(!open)}
        data-testid="language-toggle"
        className="flex items-center gap-1.5 px-3 py-2 text-sm font-sans font-medium rounded-full border border-brand-gold/20 hover:bg-brand-gold/10 transition-colors"
      >
        <Globe size={14} className="text-brand-gold" />
        <span className="text-white">{current?.flag}</span>
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 bg-white rounded-xl shadow-lg border border-brand-gold/10 py-2 min-w-[150px] z-50">
          {languages.map((l) => (
            <button
              key={l.code}
              onClick={() => { setLang(l.code); setOpen(false); }}
              data-testid={`lang-${l.code}`}
              className={`w-full text-left px-4 py-2.5 text-sm font-sans flex items-center gap-3 hover:bg-brand-sand transition-colors ${
                lang === l.code ? "text-brand-gold font-semibold" : "text-brand-text"
              }`}
            >
              <span className="w-6 text-center font-semibold text-xs">{l.flag}</span>
              {l.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
